import * as React from "react";
import Wrapper from "./src/components/wrapper";
import "./src/styles/index.scss";
import { storeUTMParams } from "./src/scripts/utm-tracking";

export const wrapPageElement = ({ element, props }) => (
  <Wrapper {...props}>{element}</Wrapper>
);

export const onRouteUpdate = () => {
  if (typeof window === "undefined") return;
  storeUTMParams();
};
